import React, { useEffect, useState } from 'react';
import { getConsent, setConsent, loadAnalytics, isAnalyticsConfigured } from '../analytics';
import './CookieConsent.css';

/**
 * Banner de consentimento (LGPD). Só aparece quando o Google Analytics está
 * configurado e o visitante ainda não escolheu. Ao aceitar, carrega o GA.
 */
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAnalyticsConfigured()) return;
    const consent = getConsent();
    if (consent === 'accepted') loadAnalytics();
    else if (consent !== 'declined') setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent('accepted');
    loadAnalytics();
    setVisible(false);
  };
  const decline = () => {
    setConsent('declined');
    setVisible(false);
  };

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
      <p className="cookie-text">
        Usamos cookies do Google Analytics apenas para contar as visitas e entender
        quais partes do site as pessoas mais acessam. Nenhum dado pessoal é vendido.
      </p>
      <div className="cookie-actions">
        <button className="btn cookie-accept" onClick={accept}>Aceitar</button>
        <button className="btn btn-secondary cookie-decline" onClick={decline}>Só o essencial</button>
      </div>
    </div>
  );
};

export default CookieConsent;
